/**
 * Order in which pasted titles must be inserted.
 *
 * Every task goes to the SAME position ("top", or after one selected task), so
 * the last insert ends up first. Inserting the titles in reverse leaves the
 * list reading top to bottom exactly as the clipboard did.
 */
export function orderForSamePositionInsert<T>(items: readonly T[]): T[] {
  return [...items].reverse()
}
